import { action, computed, observable, runInAction } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { ICFOP } from "../../model";
import { sortBy } from "../../utils";
import { toast } from "react-toastify";

class _CfopStore {

  obs = observable({
    cfops: [] as any,
    length_cfops: 0 as number,
    current_page: 1 as number,
    filter: "" as string,
    loading: false as boolean
  })

  async index_cfops(page: number, filter: string) {

    try {

      let data = {
        page: page,
        limit: 50,
        filter: filter
      }

      let resp = await apiOperacao("legislacoes").post("/legislacoes/index-cfops", data)

      this.obs.cfops = []
      this.obs.length_cfops = 0

      if (resp.data.itens.length) {

        this.obs.cfops = resp.data.itens
        this.obs.length_cfops = resp.data.count

      }

    } catch (ex) {}

  }

  async load_cfops() {

    let resp = await api_adm.get("/api/admin/codigos/cfops")

    this.obs.cfops = []

    if (resp.data.length) {

      this.obs.cfops = resp.data

    }

  }

  get(codigo: any): any {

    return this.obs.cfops.find(x => x.codigo == codigo);

  }

  async handleCreateCfop(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/cfops/create", data)

    if (resp.data.ok) {

      toast.success('CFOP criado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

  async handleUpdateCfop(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/cfops/update", data)

    if (resp.data.ok) {

      toast.success('CFOP atualizado com sucesso!', {});

      return true

    } else {

      toast.warning(resp.data.msg, {});

    }

    return false

  }

  async handleDeleteCfop(id: string) {

    let resp = await api_adm.delete(`/api/admin/codigos/cfops/${id}`)

    if (resp.data.ok) {

      toast.success('CFOP deletado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

}

export const CfopStore = new _CfopStore();
